import { CardLoader } from 'components/organisms'
import PaginationBar from 'components/organisms/pagination-bar/pagination-bar'
import withLoader from 'hocs/with-loader/with-loader'
import { Table } from 'reactstrap'
import PropTypes from 'prop-types'
import MarketingDiscountBatchTableRow from './marketing-discount-batch-table-row'

const proptypes = {
  tableProps       : PropTypes.object,
  discountBatches  : PropTypes.array,
  pagination       : PropTypes.object,
  isLoading        : PropTypes.bool,
  onClickBatchView : PropTypes.func,
  onPageChange     : PropTypes.func
}

const defaultProps = {
  tableProps       : {},
  discountBatches  : [],
  pagination       : {},
  isLoading        : true,
  onClickBatchView : () => {},
  onPageChange     : () => { }
}

const MarketingDiscountBatchTable = ({
  tableProps,
  discountBatches,
  pagination,
  isLoading,
  onClickBatchView,
  onPageChange
}) => {
  const totalColumns = 5
  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th scope="col">{ 'code' }</th>
          <th scope="col">{ 'runs at' }</th>
          <th scope="col">{ 'expires at' }</th>
          <th scope="col">{ 'status' }</th>
          <th scope="col">{ 'action' }</th>
        </tr>
      </thead>
      <tbody>
        {
          discountBatches.map((discountBatch) => (
            <MarketingDiscountBatchTableRow
              key={ `MarketingDiscountBatchTableRow-${discountBatch.id}` }
              handleClick={ () => onClickBatchView(discountBatch) }
              discountBatch={ discountBatch }
            />
          ))
        }

        {
          discountBatches.length === 0 &&
          <tr>
            <td
              colSpan={ totalColumns }
              className='bg-warning text-white'
            >
              <i className='fas fa-info-circle mr-3' />
              { 'No Marketing Discount Batch found based on your filters.' }
            </td>
          </tr>
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <div className='d-flex justify-content-between mt-3'>
        <PaginationBar
          onClickPage={ onPageChange }
          pagination={ pagination }
        />
      </div>
    </>
  )

}

MarketingDiscountBatchTable.propTypes    = proptypes
MarketingDiscountBatchTable.defaultProps = defaultProps

export default MarketingDiscountBatchTable
